<template>
    <!-- 계약서 페이지 : contract / 설명페이지 : manual -->
    <div class="container" data-contract-company="aone" data-html-name="계약 완료">
        <div class="contract">

            <HeaderBlue>
                <template v-slot:title>계약 완료</template>
            </HeaderBlue>

            <main class="complete_contract">
                <section class="default">
                    <article class="contract_done_case">
                        <div class="contract_done_contents">
                            <div class="done_msg">
                                <div class="confirm_icon"></div>
                                <div class="text">계약서 작성이 완료되었습니다.</div>
                            </div>
                        </div>
                    </article>
                </section>
            </main>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ConflictCompleteContract',
    mounted() {
        localStorage.removeItem('vuex');
        localStorage.removeItem('_secure__ls__metadata')
    },
    beforeRouteLeave(next) {
        // 뒤로가기 방지
        alert('이미 완료된 계약입니다')
        next(false)
    },
};
</script>
